/**
 * C1: the events this person opened most recently, newest first — a display preference kept in this browser only
 * (and only when preferences are allowed; see storageChoice).
 */
import { savePreference } from '@/lib/storageChoice';

const KEY = 'rmp2.events.recent';
const MAX = 4;

export function recentEventIds(): string[] {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? '[]') as unknown;
    return Array.isArray(v) ? v.filter((x): x is string => typeof x === 'string').slice(0, MAX) : [];
  } catch {
    return [];
  }
}

export function rememberEvent(id: string): void {
  const next = [id, ...recentEventIds().filter((x) => x !== id)].slice(0, MAX);
  savePreference(KEY, JSON.stringify(next));
}
